import styled from 'styled-components/macro'
import { Breakpoints } from '@volkswagen-onehub/components-core'

export const StyledFormContainer = styled.div`
  label > p:first-child {
    margin-bottom: 24px;
  }

  button {
    margin-bottom: 24px;
  }

  @media (min-width: ${Breakpoints.b560}px) {
    h1 {
      margin-bottom: 40px;
    }
  }
`
